import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { useQuery } from "react-query";
import { DayWiseReportApi, DownloadDayWiseReportApi, DownloadOutgoingAndIncomingReportApi, OutgoingAndIncomingReportApi } from "../../Api";
import { AxiosResponse } from "axios";
import { RenderPaginationButtons } from "../../../Components/Paginations";
import { useLocation, useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Dropdown } from "react-bootstrap";


interface ReportDataType {
    Date: string,
    Received: string,
    Delivered: string,
    Sent: string,
    campaign_name: string,
}

export default function MonitorDayWiseReport() {
    const [Data, setData] = useState<ReportDataType[]>([]);
    const [selectDateName, setSelectDateName] = useState("Select Date");
    const { state } = useLocation();
    const navigate = useNavigate();

    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [Filter, setFilter] = useState<{
        Sent: string,
        Delivered: string,
        Received: string,
        from_date: string,
        to_date: string,
    }>({
        Sent: "",
        Delivered: "",
        Received: "",
        from_date: "",
        to_date: "",
    });
    const [page, setPage] = useState(1);

    const Report = useQuery({
        queryKey: ["Day-Wise-Report", state?.id, page, Filter],
        queryFn: DayWiseReportApi,
        onSuccess: (resp: AxiosResponse) => {
            setData(resp.data?.data || []);
            setPage(resp.data?.info?.current_page || 1);
            setInfo(resp?.data?.info);
        },
        enabled: false,
    });

    const ReportDownload = useQuery({
        queryKey: ["Day-Wise-Report-Download", state?.id, page, Filter],
        queryFn: DownloadDayWiseReportApi,
        onSuccess: (resp: AxiosResponse) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(resp.data)
            link.download = `Day_Wise_Report_${new Date().toISOString()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        enabled: false,
    });

    useEffect(() => {
        if (!state?.id) return navigate("/report/day-wise/campaign-list");
        Report.refetch();
        // eslint-disable-next-line
    }, [page]);

    useEffect(() => {
        setPage(1)
        const handler = setTimeout(() => {
            Report.refetch();
        }, 300);

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Filter.Delivered, Filter.Received, Filter.Sent]);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
        }
    };

    const handleClearSearchFilter = () => {
        setFilter({
            Sent: "",
            Delivered: "",
            Received: "",
            from_date: "",
            to_date: "",
        });
        setSelectDateName("Select Date")
        Report.refetch();
    };

    useEffect(() => {
        Report.refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectDateName]);

    return (
        <section className="content">
            <div className="container-fluid">
                <div className="card mt-4">
                    <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                        <div className="d-flex justify-content-between w-100 flex-wrap gap-3">
                            <h2 className="mb-0 fs-3 d-block d-md-inline">Day Wise Report</h2>
                            <div className="d-flex gap-3 flex-wrap flex-grow-1 flex-md-grow-0">
                                <Dropdown style={{ zIndex: 999 }}>
                                    <Dropdown.Toggle
                                        className="fw-semibold"
                                        variant="primary"
                                        style={{ minWidth: 130 }}
                                    >
                                        {selectDateName}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="p-3 Date-Filter-Menu">
                                        <div className="d-flex flex-column">
                                            <label className="mb-2 fw-semibold">From</label>
                                            <input
                                                type="date"
                                                name="from"
                                                value={Filter.from_date}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, from_date: e.target.value })
                                                }
                                                className="form-control mb-3"
                                            />

                                            <label className="mb-2 fw-semibold">To</label>
                                            <input
                                                type="date"
                                                name="to"
                                                value={Filter.to_date}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, to_date: e.target.value })
                                                }
                                                className="form-control mb-3"
                                            />

                                            <div className="d-flex justify-content-between">
                                                <button
                                                    className="btn btn-primary w-100 me-1"
                                                    onClick={() => {
                                                        if (Filter.from_date && Filter.to_date) {
                                                            setPage(1)
                                                            setSelectDateName(`${Filter.from_date} To ${Filter.to_date}`);
                                                        }
                                                    }}
                                                >
                                                    Apply
                                                </button>

                                                <button
                                                    className="btn btn-secondary w-100 ms-1"
                                                    onClick={() => {
                                                        setSelectDateName("Select Date");
                                                        setFilter({
                                                            ...Filter,
                                                            from_date: "",
                                                            to_date: ""
                                                        });
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                                <button
                                    onClick={handleClearSearchFilter}
                                    className="btn btn-secondary d-flex align-items-center justify-content-center gap-2"
                                    style={{ minWidth: 130 }}
                                >
                                    <MdClear className="fs-5" />
                                    Clear Filter
                                </button>
                                <button
                                    onClick={() => ReportDownload.refetch()}
                                    style={{ minWidth: 130 }}
                                    className="btn btn-success d-flex align-items-center justify-content-center gap-2 text-white"
                                    disabled={ReportDownload.isFetching}
                                >
                                    <BiExport className="fs-5" />
                                    {ReportDownload.isFetching ? "Exporting.." : "Export"}

                                </button>
                                <button
                                    onClick={() => navigate(-1)}
                                    className="btn btn-info text-white d-flex align-items-center fw-semibold"
                                >
                                    <IoMdArrowRoundBack /> Back
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body border-start-0 border-end-0 p-0">
                        <div className="table-responsive" style={{ minHeight: 500 }}>
                            <table className="table table-hover table-bordered text-nowrap">
                                <thead>
                                    <tr>
                                        <th style={{ width: 200, minWidth: 200 }}>SR No</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Campaign Name</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Date</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Received</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Delivered</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Sent</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.Received}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, Received: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.Delivered}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, Delivered: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.Sent}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, Sent: e.target.value })
                                                }
                                            />
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Data && Data[0] ? (
                                        Data.map((item, i) => (
                                            <tr>
                                                <td>{i + 1 + (page - 1) * 10}</td>
                                                <td>{item?.campaign_name || " - "}</td>
                                                <td>{item?.Date || " - "}</td>
                                                <td>{item?.Received || " - "}</td>
                                                <td>{item?.Delivered || " - "}</td>
                                                <td>{item?.Sent || " - "}</td>
                                            </tr>
                                        ))
                                    ) : !Report.isFetching ? (
                                        <tr>
                                            <td colSpan={6} height={50}>
                                                <div className="text-center">
                                                    <p className="mb-0 fs-5 fw-semibold">
                                                        No data found
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                            {Report.isFetching ? (
                                <center className="mb-3">
                                    <i
                                        className=" my-2 fa loader"
                                        style={{ fontSize: "30px", color: "black" }}
                                    ></i>
                                </center>
                            ) : null}
                        </div>
                        {info && info.total_page ? (
                            <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                <RenderPaginationButtons
                                    info={info}
                                    currentPage={page}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
}
